import React, { useEffect, useState } from "react";
import axios from "axios";
import { Eyebrow } from "@/components/brand";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STAGE_TITLES = {
  define: "Define your space needs",
  rules: "Learn the location rules",
  find: "Find candidate properties",
  outreach: "Reach out to brokers & landlords",
  check: "Check a specific property",
  plan: "Plan the space",
  offer: "Make an offer",
  secure: "Secure the space",
};

const relTime = (iso) => {
  if (!iso) return "—";
  const m = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} hr ago`;
  return `${Math.round(h / 24)} d ago`;
};

export const RoadmapAdminPanel = () => {
  const token = localStorage.getItem("token");
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/roadmap/admin/summary`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setData(r.data))
      .catch(() => setData({ applicants: [], total: 0, started: 0, finished: 0 }));
  }, [token]);

  if (data === null) return null;
  const rows = data.applicants || [];

  return (
    <div className="mt-12 card-flat p-6 md:p-8" data-testid="roadmap-admin-panel">
      <div className="flex items-baseline justify-between gap-4 mb-5">
        <div>
          <Eyebrow className="mb-2">Applicant Property Roadmaps</Eyebrow>
          <p className="text-xs text-mute">Where each applicant is in the real-estate acquisition process. Read-only.</p>
        </div>
        <span className="font-mono text-xs text-mute" data-testid="roadmap-admin-count">
          {data.started} started · {data.finished} complete
        </span>
      </div>
      {rows.length === 0 ? (
        <p className="text-sm text-mute" data-testid="roadmap-admin-empty">No applicants yet.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left eyebrow border-b border-line">
                <th className="py-2 pr-4 font-normal">Applicant</th>
                <th className="py-2 pr-4 font-normal">Business type</th>
                <th className="py-2 pr-4 font-normal">Progress</th>
                <th className="py-2 pr-4 font-normal">Current stage</th>
                <th className="py-2 pr-4 font-normal">Next step</th>
                <th className="py-2 font-normal text-right">Updated</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => {
                const pct = r.progress.total ? Math.round((r.progress.done / r.progress.total) * 100) : 0;
                return (
                  <tr key={r.email} className="border-b border-line/60 last:border-0" data-testid={`roadmap-admin-row-${r.email}`}>
                    <td className="py-2.5 pr-4 text-ink-2">
                      <span className="font-medium text-ink">{r.name || r.email}</span>
                      {r.name && <span className="block text-xs text-mute font-mono">{r.email}</span>}
                    </td>
                    <td className="py-2.5 pr-4 text-ink-2">{r.business_type_label || <span className="text-mute">Not set</span>}</td>
                    <td className="py-2.5 pr-4">
                      <div className="flex items-center gap-2">
                        <div className="h-1.5 w-20 rounded-full bg-line overflow-hidden">
                          <div className={`h-full rounded-full ${r.finished ? "bg-equal" : "bg-equal/70"}`} style={{ width: `${pct}%` }} />
                        </div>
                        <span className="font-mono text-[11px] text-mute">{r.progress.done}/{r.progress.total}</span>
                      </div>
                    </td>
                    <td className="py-2.5 pr-4 text-ink-2">
                      {r.finished ? <span className="text-equal-dark font-medium">Space secured</span> : (STAGE_TITLES[r.current_stage_id] || "—")}
                    </td>
                    <td className="py-2.5 pr-4 text-mute text-xs">{r.finished ? "—" : (r.next_step_title || "—")}</td>
                    <td className="py-2.5 text-right text-mute text-xs">{r.started ? relTime(r.updated_at) : "Not started"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RoadmapAdminPanel;
